export const env = {
  apiUrl: "",
  production: true,
  accounting: "https://accounting-stage.es.mpu.gov.ua/accounting/v1",
  signWidgetUrl: "https://test.id.gov.ua/sign-widget/v2022testnew/",
  realmClientId: "estock-ui-client",
  realmUrl: "https://iam-stage.es.mpu.gov.ua/auth/realms/eStock",
  activeLocale: "uk",
  eStockHomePage: "https://estock-stage.es.mpu.gov.ua/",
  documentApi: "https://document-service-stage.es.mpu.gov.ua/v1",
  logisticsServiceBackend: "https://logistics-service-stage.es.mpu.gov.ua",
};
